import * as React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import { getStyle } from './getStyle';

export function getDeckblatt(logoURL: string, unternehmen: string): JSX.Element {
    const deckblatt = require('../../../../img/Deckblatt_VSME_Report.png');
    return <View>
        <Image src={deckblatt} />
        <View style={{ ...getStyle('deckblattTitle') }}>
            <Text style={{}}>
                Nachhaltigkeitsbericht
            </Text>
            <Text style={{ ...getStyle('deckblattTitleFirmenname') }}>
                {unternehmen} 
            </Text>
        </View>
        {logoURL && <Image src={logoURL} style={{ ...getStyle('deckblattLogo') }} />}
    </View>;
}

export function getDeckblattBack(): JSX.Element {
    const deckblatt_back = require('../../../../img/Deckblatt_2023_back.jpg');
    return <View>
        <Image src={deckblatt_back} />
    </View>;
}

